/* RESPONSIBLE TEAM: team-knowledge-foundations */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';

export default class Setting extends EmbercomBaseSerializer.extend(EmbeddedRecordsMixin) {
  attrs = {
    category: { embedded: 'always' },
    copies: { embedded: 'always' },
    appId: { serialize: false },
    consentBannerId: { serialize: false },
  };

  serialize(snapshot: any, options: any) {
    let json = super.serialize(snapshot, options);

    // Convert string ID to integer for backend compatibility
    if (json.id) {
      json.id = parseInt(json.id, 10);
    }

    return json;
  }
}
